import type { SVGProps } from 'react';
const DawnFlagMA = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-MA_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-MA_svg__a)">
      <path fill="#E33B44" d="M0 0h22v16H0z" />
      <path
        stroke="#0A6135"
        strokeWidth={1.333}
        d="M11.392 9.332 11 9.048l-.391.284-1.151.836.43-1.393.14-.447-.375-.282-1.168-.88 1.44-.014.479-.004.149-.454.447-1.36.448 1.36.15.454.477.004 1.441.013-1.168.881-.374.282.138.447.43 1.393z"
      />
    </g>
  </svg>
);
export default DawnFlagMA;
